import { ApiTriggerType } from "@superblocksteam/shared";
import { call, select } from "redux-saga/effects";
import {
  getAppProfilesInCurrentMode,
  getWorkflowProfiles,
} from "legacy/selectors/applicationSelectors";
import { getActiveAgents } from "store/slices/apisShared/utils";
import { getTriggerTypeFromApi } from "store/slices/apisV2/utils/api-utils";
import { getEnvironment } from "store/slices/application/selectors";
import { selectOnlyOrganization } from "store/slices/organizations";
import type { Agent, Profile } from "@superblocksteam/shared";
import type { Profiles } from "legacy/reducers/entityReducers/appReducer";
import type { ProfilesWithModes } from "legacy/selectors/applicationSelectors";
import type { Api } from "store/slices/apisV2/backend-types";

export function* getOpaAgents(api?: Api) {
  const organization: ReturnType<typeof selectOnlyOrganization> = yield select(
    selectOnlyOrganization,
  );

  const environment: ReturnType<typeof getEnvironment> =
    yield select(getEnvironment);
  // get profile given mode
  let profile: Profile | undefined;
  const triggerType = api ? getTriggerTypeFromApi(api) : ApiTriggerType.UI;
  if (triggerType === ApiTriggerType.UI) {
    // select app profiles if in Application mode
    const profiles: Profiles = yield select(getAppProfilesInCurrentMode);
    profile = profiles?.selected;
  } else if (api) {
    const profiles: ProfilesWithModes = yield select(
      getWorkflowProfiles,
      api.metadata.id,
    );
    profile = profiles?.editor.default;
  }

  const agentsResponse: Agent[] | { systemError: string } = yield call(
    getActiveAgents,
    {
      organization,
      environment,
      profile,
      sendNotification: false,
    },
  );

  return (agentsResponse as { systemError: string })?.systemError
    ? []
    : agentsResponse;
}
